import comp from "./DeadlineComplete";
export default comp;
